import { IPerfectScrollState } from "../scroll/perfectScrollModel";

export const optionsSelector = (s: IPerfectScrollState) => s.options;
